import { embedDimensions, getIframeStyle } from '../markdown/external_content';
import ExternalContent from './external_content.vue?vue3';
export default {
    name: 'EmbeddedIframe',
    components: {
        ExternalContent
    },
    props: {
        provider: {
            type: Object,
            required: true
        },
        src: {
            type: String,
            required: true
        },
        canonicalSrc: {
            type: String,
            required: true
        },
        width: {
            type: String,
            required: false,
            default: null
        },
        height: {
            type: String,
            required: false,
            default: null
        }
    },
    computed: {
        dimensions () {
            return embedDimensions(this.width, this.height);
        },
        iframeStyle () {
            return getIframeStyle(this.dimensions.width, this.dimensions.height);
        }
    },
    methods: {
        focusIframe () {
            this.$refs.iframe.focus();
        }
    }
};
